module.exports = __webpack_public_path__ + "static/media/no-instructions-found.0c496803.png";